import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Breadcrumbs extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        link: PropTypes.string,
      })
    ).isRequired,
  };

  static defaultProps = {
    title: '',
  };

  renderItems = () =>
    this.props.items.map((item, index) =>
      !item.link ? (
        <li key={index} className="u-breadcrumbs-root">
          {item.title}
        </li>
      ) : (
        <li key={index}>
          <a href={item.link}>{item.title}</a>
        </li>
      )
    );

  render() {
    return (
      <div>
        <ul className="u-breadcrumbs">{this.renderItems()}</ul>
      </div>
    );
  }
}
